const NavigationControls = (($) => {
    class Navigation {
        constructor(node) {
            this.node = node;
            this.$node = $(this.node);
            this.$button = this.$node.find('.navigation-button');
            this.$menu = this.$node.find('.navigation-menu');
            this.$container = this.$node.find('.navigation-container');
        }

        init() {
            this.setEventHandlers();
            this.handleWindowResize();
        }

        setEventHandlers() {
            // Toggle menu on button click
            this.$button.on('click', (event) => {
                event.stopPropagation(); // Still necessary to prevent closing immediately when toggled open
                this.toggleMenu();
            });

            // Listen for clicks on the document to handle outside clicks
            $(document).on('click', (event) => {
                // Close the menu if the click is outside the navigation components
                if (!this.$node.is(event.target) && this.$node.has(event.target).length === 0) {
                    this.closeMenu();
                }
            });

            // Do not stop propagation on $menu click, handle conditionally
            this.$menu.on('click', (event) => {
                if (!this.$container.is(event.target) && this.$container.has(event.target).length === 0) {
                    this.closeMenu(); // Close if clicking directly on $menu but outside $container
                }
            });

            // Specific handler for link clicks inside the navigation
            this.$container.find('.link').on('click', () => {
                this.closeMenu();
            });
        }

        toggleMenu() {
            const isExpanded = this.$button.attr('aria-expanded') === 'true';
            this.$button.attr('aria-expanded', !isExpanded);
            this.$menu.attr('aria-hidden', isExpanded);
            $('body').toggleClass('overflow-hidden', !isExpanded);
        }

        closeMenu() {
            this.$button.attr('aria-expanded', 'false');
            this.$menu.attr('aria-hidden', 'true');
            $('body').removeClass('overflow-hidden');
        }

        handleWindowResize() {
            $(window).on('resize', () => {
                this.closeMenu(); // Ensure the menu is closed when resizing
            });
        }
    }

    return {
        init({ selector } = {}) {
            $(selector).each((index, parent) => {
                const module = new Navigation(parent);
                module.init();
            });
        },
    };
})(window.jQuery);

// DOM Ready
(($) => {
    $(document).ready(() => {
        NavigationControls.init({
            selector: "[data-navigation]",
        });
    });
})(window.jQuery);
